// @flow weak
import {connect} from 'react-redux';
import {
  customerFailureStatusSelector,
  customerSelector,
} from '../../modules/Customer/selectors';
import {
  canChangePlanOrOptionsOfCurrentSubscriptionSelector,
  currentSubscriptionSelector,
  fetchDashboardData,
  hasRefreshedAtLeastOnceSelector,
  isCurrentSubscriptionHasActivationBonusSelector,
  isSubscriptionVisibleSelector,
} from '../../modules/Dashboard';
import {isLoadingSelector} from '../../modules/LoadingStatus';
import {currentSubscriptionPaymentAuthenticationsSelector} from '../../modules/Payment/selector';
import {isNetworkFailureSelector} from '../../modules/Usage/selectors';
import {voucherFilteredAvailableVouchersSelector} from '../../modules/Voucher';
import {eSimSelectedSuccess} from '../../modules/ESim';
import Dashboard from './Dashboard';

const mapStateToProps = state => ({
  currentSubscription: currentSubscriptionSelector(state),
  hasUnauthenticatedPayment:
    !!currentSubscriptionPaymentAuthenticationsSelector(state).length,
  isFailure: customerFailureStatusSelector(state) && !customerSelector(state),
  isFetching:
    (isLoadingSelector(state, 'fetchCustomer') && !customerSelector(state)) ||
    !hasRefreshedAtLeastOnceSelector(state),
  isLoading: isLoadingSelector(state, 'dashboard'),
  isSubscriptionVisible: isSubscriptionVisibleSelector(state),
  canAddInternational:
    canChangePlanOrOptionsOfCurrentSubscriptionSelector(state),
  isNetworkFailure: isNetworkFailureSelector(state),
  filteredAvailableVouchers: voucherFilteredAvailableVouchersSelector(state),
  canShowFreeTrialBanner: isSubscriptionVisibleSelector(state) 
  && !isNetworkFailureSelector(state) 
  && isCurrentSubscriptionHasActivationBonusSelector(state),
});

const mapDispatchToProps = {
  fetchData: fetchDashboardData,
  selectEsim: eSimSelectedSuccess,
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
